module.exports = __webpack_public_path__ + "img/map_marker.0632ef09.svg";